import { $, $$, sliderConfig } from '@utils';
import Swiper from 'swiper';
import { Navigation, Scrollbar, A11y, FreeMode } from 'swiper/modules';

function init() {
  if (!$('[data-au-naked-cards-slider]')) return;

  buildSlider();
  addExtraClasses();
}

function buildSlider() {
  $$('[data-au-naked-cards-slider]').forEach((slider) => {
    new Swiper(slider, {
      modules: [Navigation, Scrollbar, A11y, FreeMode],
      ...sliderConfig,
    });
  });
}

function addExtraClasses() {
  $$('[data-au-naked-cards-slider]').forEach((slider) => {
    const nakedSlides = slider.querySelectorAll('[data-au-naked-slide]');
    const classes = {
      2: 'au-naked-cards-slider__slide--duo',
      3: 'au-naked-cards-slider__slide--trio',
      4: 'au-naked-cards-slider__slide--quartet',
    };
    const classToAdd = classes[nakedSlides.length] || '';

    if (classToAdd) {
      nakedSlides.forEach((slide) => {
        slide.classList.add(classToAdd);
      });
    }
  });
}

export default { init };
